import { TrackJS } from "trackjs-nextjs"

import { SANDBOX, TRACKJS_TOKEN } from "./config"
import { getCurrentQuoteID } from "./helpers"

if (!SANDBOX && typeof window !== "undefined" && !TrackJS.isInstalled()) {
  TrackJS.install({
    token: TRACKJS_TOKEN,
    application: "liability-germany",
    network: { error: false },
    // for more configuration options, see https://docs.trackjs.com
  })
}

if (typeof window !== "undefined") {
  TrackJS?.addMetadata("quote_id", getCurrentQuoteID() || "no quote id")
}
